<template>
  <TableLayout :permissions="['business:inviterecord:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" >
      <el-form-item label="邀请人信息" prop="recName" >
        <el-input v-model="searchForm.recName" placeholder="请邀请人昵称/姓名/手机号 " clearable @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="被邀请人信息" prop="memberName" >
        <el-input v-model="searchForm.memberName" placeholder="被邀请人昵称/姓名/手机号 " clearable @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="完成阶段" prop="firstOrderStatus">
        <el-select  v-model="searchForm.firstOrderStatus"  placeholder="请选择完成阶段"   clearable @change="search" >
          <el-option  :value="0" label="已注册"></el-option>
          <el-option  :value="1" label="完成首单"></el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:inviterecord:exportExcel']">
        <li> <el-button type="primary" :loading="isWorking.export" v-permissions="['business:inviterecord:exportExcel']" @click="exportExcel">导出</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="openid" label="被邀请人微信ID" min-width="200px"></el-table-column>
        <el-table-column prop="memberName" label="被邀请人(昵称/姓名/手机)" min-width="200px"></el-table-column>
        <el-table-column prop="recName" label="邀请人(昵称/姓名/手机)" min-width="200px"></el-table-column>
        <el-table-column prop="firstOrderStatus" label="完成阶段" min-width="100px">
          <template slot-scope="{row}">
            <span v-if="row.firstOrderStatus ===1" class="green">完成首单</span>
            <span v-else class="orange">已注册</span>
          </template>
        </el-table-column>
        <el-table-column prop="rewardIntegral" label="积分奖励" min-width="100px">
          <template slot-scope="{row}">
           <span class="orange">{{ row.rewardIntegral || ''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="couponNames" label="优惠券奖励" min-width="150px"></el-table-column>
        <el-table-column prop="firstFinishDate" label="首单完成时间" min-width="150px"></el-table-column>
        <el-table-column prop="createDate" label="注册时间" min-width="150px"></el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
export default {
  name: 'inviteRecord',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        recName: '',
        memberName: '',
        firstOrderStatus: ''
      }
    }
  },
  created () {
    this.config({
      module: '推荐记录表',
      api: '/business/inviteRecord',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
